import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { useUserById, type UserType } from '@/api/user';
import ProfileContent from '@/app/profile/ProfileContent';
import PageError from '@/components/errors/PageError';
import { PageSpinner } from '@/components/loaders';
import { Page } from '@/components/page';
import { useMe } from '@/providers/User';

const Profile = () => {
  const { id: userId, isC99Superuser } = useMe() ?? {};
  const { user, isLoading, error, mutate } = useUserById(userId);

  const handleSubmitSuccess = (newUser: UserType) => {
    mutate({
      users: {
        getById: newUser,
      },
    });
  };

  return (
    <Page title={t`Your Profile`} pageName={user ? user.name : undefined} exampleAIQuestions={[]}>
      {isLoading && <PageSpinner />}
      {error ? (
        <PageError
          message={<Trans>An error occurred while loading your profile</Trans>}
          headingLevel={2}
        />
      ) : (
        user && (
          <ProfileContent
            user={user}
            isC99Superuser={isC99Superuser}
            onSubmitSuccess={handleSubmitSuccess}
          />
        )
      )}
    </Page>
  );
};

export default Profile;
